import Carousel from 'components/Carousel';
import PassionCategoryCard from 'components/PassionCategoryCard';
import { getMoreFilters } from 'data/filters';
import React from 'react';

import getPassionsModel from './Passions';

interface PassionCategoriesListProps {
  country?: string;
  city?: string;
  area?: string;
  aggregations?: any;
  hostAggregations?: any;
}

const CSS = require('./PassionCategoriesList.less');

function hideCard(name, availableSubCategories, hasFamilyFriendly) {
  if (!hasFamilyFriendly && name === 'Families') {
    return true;
  }
  if (
    name === 'Foodies' &&
    !availableSubCategories.includes('food-tours') &&
    !availableSubCategories.includes('wine-beer-tours') &&
    !availableSubCategories.includes('food-drink-tastings') &&
    !availableSubCategories.includes('cooking-classes') &&
    !availableSubCategories.includes('home-dinners')
  ) {
    return true;
  }
  if (
    name === 'History buffs' &&
    !availableSubCategories.includes('city-tours')
  ) {
    return true;
  }
  if (
    name === 'Style icons' &&
    !availableSubCategories.includes('shopping-tours')
  ) {
    return true;
  }
  if (
    name === 'Sporties' &&
    !availableSubCategories.includes('sports-leisure')
  ) {
    return true;
  }
  if (
    name === 'Art lovers' &&
    !availableSubCategories.includes('art-culture-tours')
  ) {
    return true;
  }
  if (
    name === 'Explorers' &&
    !availableSubCategories.includes('off-the-beaten-track')
  ) {
    return true;
  }
  if (
    name === 'Night owls' &&
    !availableSubCategories.includes('night-tours')
  ) {
    return true;
  }
  if (name === 'must-sees' && !availableSubCategories.includes('city-tours')) {
    return true;
  }
  if (
    name === 'Adventurers' &&
    !availableSubCategories.includes('day-trips') &&
    !availableSubCategories.includes('multi-day-trips') &&
    !availableSubCategories.includes('wildlife-nature')
  ) {
    return true;
  }
  if (
    name === 'Newbies' &&
    !availableSubCategories.includes('city-tours') &&
    !availableSubCategories.includes('skip-the-line-tours')
  ) {
    return true;
  }
  return false;
}

export default function PassionCategoriesList({
  country,
  city,
  area,
  aggregations,
  hostAggregations,
}: PassionCategoriesListProps) {
  if (aggregations.length === 0) {
    return null;
  }

  const passions = getPassionsModel(country, city);
  const filters = getMoreFilters(aggregations);
  const availableSubCategories = filters.toursSubcategoriesFilters
    .concat(filters.activitiesSubcategoriesFilters)
    .map(({ value }) => value);
  const hasFamilyFriendly = !!(
    aggregations?.is_family_friendly?.buckets ?? []
  ).some(({ doc_count, key }) => key === 1 && doc_count > 0);

  return (
    <div className={CSS.ListContainer}>
      <Carousel className={CSS.Carousel}>
        {passions.map((passion) => {
          const hide = hideCard(
            passion.name,
            availableSubCategories,
            hasFamilyFriendly,
          );
          return (
            <PassionCategoryCard
              key={passion.text}
              name={passion.name}
              text={passion.text}
              image={passion.image}
              url={passion.url(aggregations, hostAggregations)}
              area={area}
              hide={hide}
            />
          );
        })}
      </Carousel>
    </div>
  );
}
